import {ColumnStore} from "@bryntum/schedulerpro";
import ColumnBase from "./ColumnBase.jsx";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";

export default class NoteChangeRoleColumn extends ColumnBase {

  static get $name() {
    return "SwivuNoteChangeRoleColumn";
  }

  static get type() {
    return WIDGET_KEYS.swivuNoteChangeRoleColumn;
  }

  static get defaults() {
    return {
      flex: 1,
      groupable: false,
      filterable: false,
      editor : {
        type  : "combo",
        displayField: "roleName",
        valueField: "grantId",
      },
    }
  }

  defaultRenderer({ value }) {
    if (this.context) {
      if (value) {
        return this.context.boardManager.boardNameStore.appRoles.find((role) => role.id === value).name.concat(" +");
      }
      return "Select Role";
    }
  }

  getPickerItemsCls(record) {
    // // 1 is Admin, 2 is Executive and so on. the lower the grant is, the higher it will have authority
    if (!this.context.user.can(record.grantId)) {
      return "swivu-bryntum-combo-picker-disabled";
    }
    return "";
  }

  onBeforePickerItemSelect({ record }) {
    return !record.isPhantom && this.context.user.can(record.grantId)
  }

  getGrantForRole(roleRecord) {
    return Math.min.apply(Math, roleRecord.grants.map((g) => g.value));
  }

  onLoad(_project, { context }) {
    this.context = context;
    this.swivuAppRoles = context.boardManager.boardNameStore.appRoles.filter((role) => role.grants.length);
    this.swivuAppRoles = this.swivuAppRoles.map((roleRecord) => ({
      roleName: roleRecord.name,
      grantId: this.getGrantForRole(roleRecord)
    }))
    this.editor.store = this.swivuAppRoles;
    this.editor.picker.getItemCls = this.getPickerItemsCls.bind(this);
    this.editor.picker.on("beforeItem", this.onBeforePickerItemSelect.bind(this), this);
  }
}

ColumnStore.registerColumnType(NoteChangeRoleColumn);
